import { useId } from 'react';
import { inputCls } from '../ui/styles';
import { money } from '../../core/format/currency';
import { toCents } from '../../core/format/currency';
import { giftCardAmounts } from './kassaLabels';
import { useFeatures } from '../../hooks/useFeatures';
import type { SaleComposerControl } from './useSaleComposer';

/**
 * Iets op de bon zetten: een behandeling, een product, een kuur vooruit of een cadeaubon. Keuzelijsten
 * die na het kiezen weer leeg zijn, zodat ze ook op de telefoon met één tik werken. Een ander bedrag
 * voor de cadeaubon pas je daarna in de regel aan.
 */
export function AddLineBar({
  c
}: {
  c: SaleComposerControl;
}) {
  const id = useId();
  const treatments = c.catalog.treatments.filter(t => !t.online);
  const {
    prepaidKuur
  } = useFeatures();
  const kuren = prepaidKuur ? treatments.filter(t => t.kuur && t.kuur.price > 0) : [];
  // Alleen verkoopbare producten: geen cadeaubonnen of kuren (die hebben hun eigen weg).
  const products = c.catalog.products.filter(p => p.kind !== 'giftcard' && p.kind !== 'kuur').sort((a, b) => a.name.localeCompare(b.name, 'nl'));
  const hasKuur = c.lines.some(l => l.input.kind === 'kuur');
  return <div className={`grid gap-3 sm:grid-cols-2 ${prepaidKuur ? 'xl:grid-cols-4' : 'xl:grid-cols-3'}`} data-id="element-2240" data-mp="2tz1r2dwkbb1">
      <label htmlFor={`${id}-t`} className="block" data-id="element-2241" data-mp="3uxrgxtpix3h5">
        <span className="mb-1 block text-[12px] text-muted" data-id="element-2242" data-mp="3uz2o83i6gtd0">Behandeling erbij</span>
        <select id={`${id}-t`} value="" onChange={e => {
        if (e.target.value) c.addTreatment(e.target.value);
      }} className={inputCls} data-id="element-2243" data-mp="379889d2kaooj">
          <option value="" data-id="element-2244" data-mp="3g9obqmjb1vte">Kies…</option>
          {treatments.map(t => <option key={t.slug} value={t.slug} data-id="element-2245" data-mp="3b9iqpp7jj7ka">
              {t.name}
              {t.price != null ? ` · ${money(toCents(t.price))}` : ''}
            </option>)}
        </select>
      </label>
      <label htmlFor={`${id}-p`} className="block" data-id="element-2246" data-mp="qkcivxuy8pqu">
        <span className="mb-1 block text-[12px] text-muted" data-id="element-2247" data-mp="qlxelqt02eqa">Product erbij</span>
        <select id={`${id}-p`} value="" onChange={e => {
        if (e.target.value) c.addProduct(e.target.value);
      }} className={inputCls} data-id="element-2248" data-mp="3kb9jidr3vdv5">
          <option value="" data-id="element-2249" data-mp="3td0qdlxdtqql">Kies…</option>
          {products.map(p => <option key={p.id} value={p.id} data-id="element-2250" data-mp="24mumsg9y8o7">
              {p.name} · {money(toCents(p.price))}
              {(() => {
            const level = c.salonLevel(p.id);
            return level !== null && level <= 0 ? ' · op volgens telling' : '';
          })()}
            </option>)}
        </select>
      </label>
      {prepaidKuur && <label htmlFor={`${id}-k`} className="block" data-id="element-2251" data-mp="3fc6egtb4l7n6">
          <span className="mb-1 block text-[12px] text-muted" data-id="element-2252" data-mp="3fdr6ab622chc">Kuur vooruit betalen</span>
          <select id={`${id}-k`} value="" disabled={hasKuur || kuren.length === 0} onChange={e => {
        if (e.target.value) c.addKuur(e.target.value);
      }} className={inputCls} data-id="element-2253" data-mp="2hwj0y5s7codg">
            <option value="" data-id="element-2254" data-mp="2ad9tii39azr1">{hasKuur ? 'Er staat al een kuur op' : 'Kies…'}</option>
            {kuren.map(t => <option key={t.slug} value={t.slug} data-id="element-2255" data-mp="25d57ydnhrety">
                {t.name} · {t.kuur?.sessions}× · {money(toCents(t.kuur?.price ?? 0))}
              </option>)}
          </select>
        </label>}
      <label htmlFor={`${id}-g`} className="block" data-id="element-2256" data-mp="1wfcvrid2gnas">
        <span className="mb-1 block text-[12px] text-muted" data-id="element-2257" data-mp="1rmjpgq1y96wl">Cadeaubon verkopen</span>
        <select id={`${id}-g`} value="" onChange={e => {
        const cents = Number(e.target.value);
        if (cents > 0) c.addGiftCard(cents);
      }} className={inputCls} data-id="element-2258" data-mp="1mnypmrqm0p8o">
          <option value="" data-id="element-2259" data-mp="1dlz53pgdz30z">Kies een bedrag…</option>
          {giftCardAmounts.map(cents => <option key={cents} value={cents} data-id="element-2260" data-mp="18pihcwd3mqof">
              {money(cents)}
            </option>)}
        </select>
      </label>
    </div>;
}